/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { ISnackbarData } from "@/components/md/MdSnackbar";
import { IVariablePickerData } from "@/store/types";
import { GetterTree } from "vuex";
import { IRootState } from "./state";

export enum Getters {
  IS_INITIALIZED = "IS_INITIALIZED",
  GET = "GET",
  SIDENAV_RAIL = "SIDENAV_RAIL",
  GET_SNACKBAR = "GET_SNACKBAR",
  GET_VARIABLE_PICKER = "GET_VARIABLE_PICKER",
  IS_LOADER_SHOWN = "IS_LOADER_SHOWN",
}

export interface IGetters {
  [Getters.IS_INITIALIZED](state: IRootState): boolean;
  [Getters.GET](state: IRootState): boolean;
  [Getters.SIDENAV_RAIL](state: IRootState): boolean;
  [Getters.GET_SNACKBAR](state: IRootState): ISnackbarData | null;
  [Getters.GET_VARIABLE_PICKER](state: IRootState): IVariablePickerData | null;
  [Getters.IS_LOADER_SHOWN](state: IRootState): boolean;
}

export const getters: GetterTree<IRootState, IRootState> & IGetters = {
  [Getters.IS_INITIALIZED]: (state: IRootState) => {
    return state.initialized;
  },
  [Getters.GET]: (state: IRootState) => {
    return state.root;
  },
  [Getters.SIDENAV_RAIL]: (state: IRootState) => {
    return state.sidenavRail;
  },
  [Getters.GET_SNACKBAR]: (state: IRootState) => {
    return state.snackbar;
  },
  [Getters.GET_VARIABLE_PICKER]: (state: IRootState) => {
    return state.variablePicker;
  },
  [Getters.IS_LOADER_SHOWN]: (state: IRootState) => {
    return state.showLoader;
  },
};
